import React from 'react'
import classes from './tableData.module.css'
const Data = ({children}) =>{
    return(
        <td className={classes.data}>
            {children}
        </td>
    )
}
export default Data;